import { createAction, handleActions } from 'redux-actions';

/**
 * Action
 * @type {string}
 */
const INIT_CHANGE_LOADING = 'filter/INIT_CHANGE_LOADING';
const FILTER_CHANGE_LOADING = 'filter/FILTER_CHANGE_LOAIDNG';
const TABLE_CHANGE_LOADING = 'table/TABLE_CHANGE_LOADING';
const GRAPH_CHANGE_LOADING = 'graph/GRAPH_CHANGE_LOADING';

/**
 * // Action Creators
 */
export const filterChangeLoading = createAction(FILTER_CHANGE_LOADING);
export const tableChangeLoading = createAction(TABLE_CHANGE_LOADING);
export const graphChangeLoading = createAction(GRAPH_CHANGE_LOADING);
export const initChangeLoading = createAction(INIT_CHANGE_LOADING);

const initialState = {
  loadingState: {
    table: false,
    graph: false,
  },
};

/**
 * reducer
 */
const uiReducer = handleActions(
  {
    [FILTER_CHANGE_LOADING]: (state, { payload }) => {
      return {
        loadingState: {
          ...state.loadingState,
          filter: payload,
        },
      };
    },

    [INIT_CHANGE_LOADING]: () => {
      return initialState;
    },

    [TABLE_CHANGE_LOADING]: (state, { payload }) => {
      return {
        loadingState: {
          ...state.loadingState,
          table: payload,
        },
      };
    },

    [GRAPH_CHANGE_LOADING]: (state, { payload }) => {
      return {
        loadingState: {
          ...state.loadingState,
          graph: payload,
        },
      };
    },
  },
  initialState
);

export default uiReducer;
